import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { AuthorizationStatus } from '../enums/authorization-status.enum';
import { ApplicationLoginAuth } from '../interfaces/application-login-auth.interface';
import { ApplicationLoginResult } from '../interfaces/application-login-result.interface';
import { ApplicationLogin } from '../interfaces/application-login.interface';
import { AsamcoAuthService } from '@asamco/base';
import { skipAuthInterceptor } from '@asamco/utils';
import { AuthFlowInput } from '@asamco/application-link/shared';
import { AuthFlowOutput } from '@asamco/application-link/shared';

interface CSPSessionCreate {
	token: string;
	backendUrl: string;
	frontendUrl: string;
}

@Injectable({
	providedIn: 'root',
})
export class ApplicationLoginService {
	private readonly url: string = 'applicationlogin';

	constructor(private http: HttpClient, private auth: AsamcoAuthService) {}

	// public get(fromApplicationID: number, toApplicationID: number): Observable<ApplicationLogins> {
	// 	let ownParams = new HttpParams();

	// 	ownParams = ownParams.set('toApplicationID', toApplicationID.toString());
	// 	ownParams = ownParams.set('fromApplicationID', fromApplicationID.toString());
	// 	return this.http.get<ApplicationLogins>(this.url + '/getToFrom', { params: ownParams });
	// }

	public getFields(): Observable<string[]> {
		return this.http.get<string[]>(this.url + '/getFields');
	}

	public testLogin(linkId: number, appSide: string, login: ApplicationLogin, fromLinkType: string) {
		if (['csp', 'csp-fs'].includes(fromLinkType)) {
			let headers = new HttpHeaders();
			headers = headers.set('X-Target-Backend', 'CSPPlatform');
			headers = headers.set('LinkID', `${linkId}`);
			const controller = this.getController(fromLinkType, appSide);
			return this.http.get<ApplicationLoginResult>(`${controller}/testLogin`, { headers: headers });
		} else {
			return this.http.post<ApplicationLoginResult>(this.url + '/testLogin', {applicationLoginId: login.id, linkId: linkId });
		}
	}

	private getController(fromLinkType: string, appSide: string) {
		if (fromLinkType === 'csp') {
			if (appSide === 'from') {
				return 'cmp';
			}
			return 'msp';
		} else {
			if (appSide === 'from') {
				return 'cmpfs';
			}
			return 'fs';
		}
	}

	public testLoginRaw(applicationLogin: ApplicationLogin, isEncrypted: boolean): Observable<boolean> {
		return this.http.post<boolean>(this.url + '/testLoginRaw', { applicationLogin: applicationLogin, isEncrypted: isEncrypted });
	}

	public saveLogin(id: number, loginType: string, login: ApplicationLogin) {
		return this.http.post<ApplicationLoginResult>(this.url + '/saveLogin', { LinkID: id, loginType, login });
	}

	public createNewLogin(id: number, loginType: string, login: ApplicationLogin) {
		return this.http.post<ApplicationLoginResult>(this.url + '/createNewLogin', { LinkID: id, loginType, login });
	}

	public updateExistingLogin(id: number, loginType: string, login: ApplicationLogin) {
		return this.http.post<ApplicationLoginResult>(this.url + '/updateExistingLogin', { LinkID: id, loginType, login });
	}

	public authorize(login: ApplicationLogin, linkId: number, appSide: string, dropdownId: number) {
		//TODO: Add struct for ApplicationAuthorization
		return this.http.post<ApplicationLoginAuth>(this.url + '/authorize', {
			applicationLogin: login,
			LinkID: linkId,
			AppSide: appSide,
			DropDownSelectedId: dropdownId,
		});
	}

	public authFlow(login: ApplicationLogin, authFlowInput: AuthFlowInput) {
		return this.http.post<AuthFlowOutput>(this.url + '/authFlow', { applicationLogin: login, authFlowInput: authFlowInput });
	}

	public pollAuthorizeStatus(authGuid: string) {
		return this.http.get<AuthorizationStatus>(this.url + '/getAuthorizationStatus/' + authGuid);
	}

	public canConnect(applicationLogin: ApplicationLogin) {
		return this.http.post<boolean>(this.url + '/canConnect', { applicationLogin: applicationLogin });
	}

	public deleteApplicationLogin(applicationLoginId: number): Observable<boolean> {
		return this.http.get<boolean>(this.url + '/deleteLogin/' + applicationLoginId);
	}

	public getApplicationLoginsByApplicationId(applicationId: number, companyId: number) {
		return this.http.post<ApplicationLogin[]>(this.url + '/' + applicationId + '/' + companyId, null);
	}

	public checkIfLoginIsUsed(applicationLoginId: number) {
		return this.http.get<boolean>(this.url + '/isLoginUsed/' + applicationLoginId);
	}
}
